<template>
  <v-container>
    <v-card flat
      ><v-card-title>
        <h4>Taxons non enregistrés</h4>
      </v-card-title>
      <v-banner
          v-if="unregisteredTaxons.length > 0"
          color="warning"
          dark
          elevation="2"
          single-line
          ><v-icon slot="icon" dark size="30">
            mdi-alert-octagon-outline </v-icon
          >{{ unregisteredTaxons.length }} variables are not in the APD taxonomy
          dictionnary</v-banner
        >
      <v-card-text>
        <v-data-table
          :headers="headers"
          sort-by="datasetname"
          :items="unregisteredTaxons"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <UnregisteredTaxonsEdit
      :dialog.sync="dialogEdit"
      :editedItem.sync="editedItem"
      :editedIndex.sync="editedIndex"
      :selectedTaxon.sync="selectedTaxon"
      :unregisteredTaxons.sync="unregisteredTaxons"
    ></UnregisteredTaxonsEdit>
  </v-container>
</template>

<script>
import taxons from "../../../api/taxons.js";
import { mapActions, mapGetters } from "vuex";
import UnregisteredTaxonsEdit from "./UnregisteredTaxonsEdit.vue";

export default {
  components: {
    UnregisteredTaxonsEdit,
  },
  data() {
    return {
      dialogEdit: false,
      editedItem: {
        authortaxon_name: "",
        taxon_name: "",
        id_family: "",
        family_name: "",
        plant_habit: "",
        id_pollen_habit: "",
        pollen_habit_code: "",
        id_taxon: "",
      },
      editedIndex: null,
      checkbox: false,
      selectedTaxon: [],
      unregisteredTaxons: [],
      headers: [
        {
          text: "Variable Name",
          align: "start",
          value: "authortaxon_name",
        },
        {
          text: "Dataset Title",
          value: "datasetname",
        },
        {
          text: "APD moderne/fossile",
          value: "pollen",
        },
        {
          text: "Edit",
          value: "actions",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchAuthorTaxonsDeep"]),
    ...mapActions(["fetchTaxons", "fetchPollenHabits", "fetchTaxonFamilies"]),
    ...mapActions("auth", ["setIsLoading", "setLoadingMessage"]),
    async getUnregisteredTaxons() {
      this.setLoadingMessage(
        "Checking taxonomies on dictionary. Please wait..."
      );
      this.setIsLoading(true);
      let res = await taxons.getUnregisteredTaxons();
      this.unregisteredTaxons = res.data;
      this.setIsLoading(false);
      this.setLoadingMessage("");
    },
    editItem(item) {
      this.editedIndex = this.unregisteredTaxons.indexOf(item);
      this.editedItem = Object.assign(this.editedItem, item);
      /* this.selectedTaxon = this.getTaxonsAll.filter(
        (t) => t.id_taxon === item.id_taxon
      ); */
      this.selectedTaxon = [];
      this.dialogEdit = true;
    },
  },
  computed: {
    ...mapGetters(["getTaxonsAll"]),
  },
  mounted() {
    this.getUnregisteredTaxons();
    this.fetchTaxons();
    this.fetchPollenHabits();
    this.fetchTaxonFamilies();
  },
};
</script>

<style>
</style>